import union from 'lodash/union'
import without from 'lodash/without'

const paginate = ({
  types,
  createType,
  insertType,
  idCombiner,
  deleteType,
  mapActionToKey,
  prependCreate
}) => {
  if (!Array.isArray(types) || types.length !== 3) {
    throw new Error('Expected types to be an array of three elements.')
  }
  if (!types.every(t => typeof t === 'string')) {
    throw new Error('Expected types to be strings.')
  }

  const [ requestType, successType, failureType ] = types

  const updatePagination = (state = {
    isFetching: false,
    nextPageUrl: undefined,
    pageCount: 0,
    ids: []
  }, action) => {
    switch (action.type) {
      case requestType:
        return {
          ...state,
          isFetching: true
        }
      case successType:
        let ids

        if (action.payload.reload) {
          ids = action.payload.result
        } else {
          ids = combineIds(action, state.ids, action.payload.result, idCombiner)
        }

        return {
          ...state,
          ids,
          isFetching: false,
          nextPageUrl: action.payload.meta ? action.payload.meta.links.next : null,
          pageCount: (state.pageCount || 0) + 1
        }
      case failureType:
        return {
          ...state,
          isFetching: false
        }
      case createType:
        let newIds
        if (prependCreate) {
          newIds = union([ action.payload.result ], state.ids)
        } else {
          newIds = union(state.ids, [ action.payload.result ])
        }

        return {
          ...state,
          ids: newIds
        }
      case insertType:
        return {
          ...state,
          ids: union(state.ids, [ action.payload ])
        }
      case deleteType:
        return {
          ...state,
          ids: without(state.ids, action.payload.resourceId)
        }
      default:
        return state
    }
  }

  return (state = {}, action) => {
    if (mapActionToKey && action.type === deleteType) {
      state = removeIdFromEachIds(state, action)
    }

    // Update pagination by key
    switch (action.type) {
      case requestType:
      case successType:
      case createType:
      case insertType:
      case deleteType:
      case failureType:
        const key = mapActionToKey && mapActionToKey(action)
        if (key && typeof key !== 'string') {
          throw new Error('Expected key to be a string.')
        }

        if (key) {
          return {
            ...state,
            [key]: updatePagination(state[key], action)
          }
        }

        return {
          ...state,
          ...updatePagination(state, action)
        }

      default:
        return state
    }
  }
}

export default paginate

function removeIdFromEachIds (state, action) {
  Object.keys(state).forEach(key => {
    state = {
      ...state,
      [key]: {
        ...state[key],
        ids: without(state[key].ids, action.payload.resourceId)
      }
    }
  })

  return state
}

function combineIds (action, existing, incoming, idCombiner) {
  if (idCombiner) {
    return idCombiner(action, existing, incoming)
  } else {
    return union(existing, incoming)
  }
}



// WEBPACK FOOTER //
// ./src/reducers/create-paginator.js